import { GenIcon } from '../helpers/IconBase.es.js';

const MasterCardColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M1.56525 3C0.7005 3 0 3.71097 0 4.58768V19.4116C0 20.2883 0.7005 21 1.56525 21H22.4348C23.2995 21 24 20.2883 24 19.4116V4.58768C24 3.71097 23.2995 3 22.4348 3H1.56525Z",
          fill: "#233746"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M5.21704 11.9997C5.21704 14.3388 7.08604 16.2348 9.39154 16.2348C11.6963 16.2348 13.5653 14.3388 13.5653 11.9997C13.5653 9.66053 11.6963 7.76385 9.39154 7.76385C7.08604 7.76385 5.21704 9.66053 5.21704 11.9997Z",
          fill: "#E32027"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M10.4004 11.9997C10.4004 14.3388 12.2694 16.2348 14.5741 16.2348C16.8796 16.2348 18.7486 14.3388 18.7486 11.9997C18.7486 9.66053 16.8796 7.76385 14.5741 7.76385C12.2694 7.76385 10.4004 9.66053 10.4004 11.9997Z",
          fill: "#F89F1D"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M10.4004 11.9996C10.4004 13.2926 10.9839 14.5135 11.9829 15.316C12.9826 14.5135 13.5654 13.2926 13.5654 11.9996C13.5654 10.7067 12.9826 9.48497 11.9829 8.68326C10.9839 9.48497 10.4004 10.7067 10.4004 11.9996Z",
          fill: "#F06723"
        }
      }
    ]
  })(props);
};

export { MasterCardColored };
